module.exports = __webpack_public_path__ + "static/media/code5.70e770f3.PNG";